import type { IFaqCategory } from './faq-types';

export const faqLearning: IFaqCategory = {
  title: 'Learning & Content',
  slug: 'learning-and-content',
  items: [
    {
      question: 'How does spaced repetition work?',
      answer:
        'Cool Mate uses the Leitner spaced repetition system to schedule reviews at the optimal time. Words you find easy are reviewed less often, while challenging words appear sooner. This scientifically-backed method helps you build lasting vocabulary efficiently.',
    },
    {
      question: 'What kind of content is available?',
      answer:
        'Content comes from real-world entertainment and everyday conversations. Each lesson is short, focused, and paired with interactive exercises that help you understand vocabulary in context.',
    },
    {
      question: 'How are collections organized?',
      answer:
        'Content is organized into curated collections grouped by theme, difficulty, or source. You can browse collections and choose what interests you most.',
    },
    {
      question: 'Can I learn languages other than English?',
      answer:
        'Cool Mate focuses on English learning. Translations are currently available in 12 languages to help you understand content in your native language.',
    },
  ],
};
